import React from 'react'
import {Minus, Plus} from 'lucide-react'

interface Props {
  typeButton: 'minus' | 'plus'
  value: number
  disabled?: boolean
  size?: number
  onClick: () => void
}

export const ButtonPlusMinus: React.FC<Props> = (props) => {
  const {typeButton, value, disabled, size, onClick} = props

  const defaultSize = 30

  return (
    <button
      className="p-2 rounded-xl border bg-blue-t0 text-white hover:bg-[#2a3d7a] transition-all shadow disabled:opacity-40 disabled:cursor-not-allowed"
      value={value} name="add"
      onClick={onClick}
      disabled={disabled}
    >
      {typeButton === 'plus' &&
        <Plus size={size || defaultSize} />
      }
      {typeButton === 'minus' &&
        <Minus size={size || defaultSize} />
      }
    </button>
  )
}